import axios from 'axios'
import global from '@/global/variable.js'

// 获取待检测列表
export function getList(data) {
  const url = global.requestUrl + '/dualCheck/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&status=' + data.status + '&plateNumber=' + data.plateNumber
  return axios.get(url)
}

// 罐口卸料列表
export function getHistoryList(data) {
  const url = global.requestUrl + '/materialFilling/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&port=' + data.port
  return axios.get(url)
}

// 粉料检测申请
export function createOne(data) {
  const url = global.requestUrl + '/dualCheck/create'
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}

// 粉料检测审核
export function updateOne(data) {
  const url = global.requestUrl + '/dualCheck/check'
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}

// 获取消息推送列表
export function getConfigList(data) {
  const url = global.requestUrl + '/portConfig/list'
  return axios.get(url)
}

// 更新消息推送信息
export function updateConfigOne(data) {
  const url = global.requestUrl + '/portConfig/update'
  return axios.post(url, data)
}

// 罐料口开启
export function openOne(data) {
  const url = global.requestUrl + '/equip/openPort?port=' + data.port + '&reason=' + data.reason
  return axios.get(url)
}